module.exports = __webpack_public_path__ + "img/angles-down.442a4fe8.svg";